import { render, staticRenderFns } from "./VTabsContent.vue?vue&type=template&id=15468347"
import script from "./VTabsContent.vue?vue&type=script&lang=js"
export * from "./VTabsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports